// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"SliderControl-module--arrowButton--270VT"};